// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"574":"acdb3939","628":"902d539e","660":"1528bef7","809":"7b1f8a9a","924":"902d539e","928":"902d539e"}[chunkId] + ".chunk.css";
};